module.exports = __webpack_public_path__ + "static/media/mari_desktop1.485a238b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mari/mari_desktop1.png
// module id = 90
// module chunks = 0